import { produce } from 'immer'
import { first, keys, map, omit, uniqueId } from 'lodash'
import { TableHorizontalData } from '../components/TableHorizontal'

export interface ReportPaginateResponseData {
  id: number
  [key: string]: any
}

export default {
  headers<Data> (data: TableHorizontalData<Data>[]) {
    const dataItem = omit(first(data), 'id')
    if (!dataItem) return []
    const dataItemKeys = keys(dataItem)
    return map(dataItemKeys, key => {
      const data = { heading: key, path: key, date: false }
      if (key === 'Created at') data.date = true
      return data
    })
  },

  data<Data> (data: Data[]) {
    return map(data, row => {
      return produce(row, (draftRow: any) => {
        draftRow.id = Number(uniqueId())
      }) as TableHorizontalData<Data>
    })
  }
}
